import { Link, Navigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'

const FEATURES = [
  {
    icon: '01',
    title: 'Три уровня доступа',
    text: 'Личный, по ссылке или на всю компанию — без случайных просмотров.',
  },
  {
    icon: '02',
    title: 'Бронь без спойлеров',
    text: 'Коллеги видят «забронировано», владелец не узнает кто именно.',
  },
  {
    icon: '03',
    title: 'Скидываемся вместе',
    text: 'Взносы на дорогой подарок: кто сколько готов, без таблиц в чате.',
  },
] as const

export function LandingPage() {
  const { user, loading } = useAuth()
  if (!loading && user) return <Navigate to="/app" replace />

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="nav-actions" style={{ marginLeft: 'auto' }}>
          <Link className="btn btn-ghost" to="/auth">
            Войти
          </Link>
          <Link className="btn btn-primary" to="/auth?mode=register">
            Начать
          </Link>
        </div>
      </header>

      <section className="hero" aria-labelledby="landing-title">
        <p className="hero-kicker">корпоративные вишлисты</p>
        <h1 className="hero-brand" id="landing-title">
          W<span>ish</span>
        </h1>
        <p className="hero-line">Списки без хаоса. Подарки без спойлеров.</p>
        <p className="hero-lead">
          Личные и company-wide списки, шаринг по ссылке, бронь «беру в подарок» и взносы —
          кто сколько готов скинуться.
        </p>
        <div className="hero-cta">
          <Link className="btn btn-primary" to="/auth?mode=register">
            Создать компанию
          </Link>
          <Link className="btn" to="/auth?mode=join">
            Invite-код
          </Link>
        </div>

        <div className="landing-features" aria-label="Возможности">
          {FEATURES.map((f) => (
            <div key={f.icon} className="feature-chip">
              <span className="feature-icon" aria-hidden="true">
                {f.icon}
              </span>
              <div>
                <strong>{f.title}</strong>
                <p>{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
